
import { defineComponent, PropType } from "vue";

/**
 * Las formas las define el BACKEND
 * (`functions/src/System/Migration/verifyCatalog.ts`) y viven en un `.ts`
 * aparte: `shims-vue.d.ts` declara `*.vue` con un solo export —el default—, así
 * que un `export interface` aquí dentro NO existiría para quien importe este
 * fichero. Ver la cabecera de `catalogTypes.ts`.
 */
import type { CatalogReport, DocCatalogo } from "./catalogTypes";

/**
 * Qué significa que un campo NO ESTÉ. Ausente no es cero, y el caso que lo
 * demuestra es `scholarshipPoints`: sin él, la beca hereda de los binarios —
 * que en los Lite son 0. O sea, cero puntos de beca, sin que nadie lo escriba.
 */
const IMPLICA_AUSENTE: Record<string, string> = {
  scholarshipPoints:
    "ausente ≠ 0: hereda de los puntos de binario, que aquí son 0 ⇒ CERO puntos de beca",
  addToBinaryTree:
    "ausente ≠ false: `undefined !== false` ⇒ SÍ entra al binario",
  binaryPoints: "ausente se lee como 0",
};

export default defineComponent({
  name: "CatalogCheck",
  props: {
    report: { type: Object as PropType<CatalogReport>, required: true },
  },
  computed: {
    nuevos(): DocCatalogo[] {
      return this.report.docs.filter((d) => d.clase === "nuevo");
    },
    comprables(): string[] {
      return this.report.veredicto.comprables;
    },
    viasAbiertas(): string[] {
      return this.report.veredicto.viasAbiertas;
    },
    hora(): string {
      return new Date(this.report.generadoEn).toLocaleTimeString();
    },
    grupos(): Array<{
      clase: string;
      titulo: string;
      porQue: string;
      docs: DocCatalogo[];
    }> {
      const de = (clase: DocCatalogo["clase"]) =>
        this.report.docs.filter((d) => d.clase === clase);
      return [
        {
          clase: "nuevo",
          titulo: "Los CUATRO nuevos",
          porQue:
            "los crea el sembrador. Si falta uno, se siembra — y tienen que poder venderse.",
          docs: de("nuevo"),
        },
        {
          clase: "heredado",
          titulo: "El HEREDADO",
          porQue:
            "nadie lo siembra: llega en la copia. Si falta, el problema es la copia, no el sembrador.",
          docs: de("heredado"),
        },
        {
          clase: "retirado",
          titulo: "Los CINCO retirados, pero vivos",
          porQue:
            "existen para que quien los tiene pueda RENOVAR. No para venderse.",
          docs: de("retirado"),
        },
      ];
    },
  },
  methods: {
    implicaAusente(campo: string): string {
      return IMPLICA_AUSENTE[campo] ?? "el campo no existe en el documento";
    },
  },
});
